/**
 * The member's tickets as the routes send them, and the one query key the
 * tickets page and the account rail share.
 */

import type { BadgeTone, TicketCategory, TicketStatus } from '@metal/shared'

/** One row of `GET /tickets`, exactly as the route sends it. */
export interface TicketRow {
  ticketNo: number
  ticketNoFa: string
  category: TicketCategory
  categoryFa: string
  subjectFa: string
  status: TicketStatus
  statusFa: string
  statusTone: BadgeTone
  lastMessageAt: string
  lastMessageAtFa: string
  messageCount: number
}

export interface TicketsResponse {
  items: TicketRow[]
  total: number
  page: number
  pageSize: number
  pageCount: number
  counts: { open: number; answered: number; closed: number }
}

/** One ticket and its thread, `GET /tickets/:ticketNo`. */
export interface TicketView extends TicketRow {
  openedAtFa: string
  messages: Array<{ at: string; atFa: string; fromStaff: boolean; byName: string; textFa: string }>
  canReply: boolean
  canClose: boolean
}

export const ticketsKey = (query: Record<string, unknown>) => ['tickets', query] as const
